<template>
	<div>
		<a-modal title="余额充值" :width="480" :visible="visible"  @cancel="handleCancel" >
			<template slot="footer" >
				<a-button  key="back"  @click="handleCancel">
					取消
				</a-button>
				<a-button  key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					确定充值
				</a-button>
			</template>
			<div>
				<div class=" flex center">
					<a-spin :spinning="showMemberLoading">
						<a-form-model-item required label="查找用户" v-if="JSON.stringify(form.member) == '{}'">
							<div class="alcenter flex">
								<a-input-search v-model="search.mobile" placeholder="请输入用户手机号"  style="width: 160px" @search="onSearch" />
								<div class="ml10 flex alcenter ft12 ftw400 cl-notice" v-if="msgStatus">
									<div>暂无该用户，请重新输入 </div>
									<!-- <div class="cl-theme clickAct" @click="addMemberAct()">或添加会员</div> -->
								</div>
							</div>
						</a-form-model-item>
						
						<a-form-model-item  label="查找的用户" v-if="JSON.stringify(form.member) != '{}'">
							<div class="flex alcenter ml10">
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-main">昵称：</div>
									<div class="ft14 ftw400 cl-black ml5">{{form.member.nick_name}}</div>
								</div>
								
								<div class="flex alcenter ml20">
									<div class="ft14 ftw400 cl-main">手机号：</div>
									<div class="ft14 ftw400 cl-black ml5">{{form.member.mobile}}</div>
								</div>
								
								<div class=" ml20">
									<a-button type="primary" @click="reChooseAct()">重新选择</a-button>
								</div>
							</div>
						</a-form-model-item>
					</a-spin>
				</div>

				<div class=" flex center">
					<div class="detail-modal-balance-recharge">
						<div class="pt15 ft14 ftw600 cl-main">实际充值金额</div>
						<div class="detail-modal-balance-recharge-content">
							<div style="position: relative;">
								<a-input-number  v-model="form.balance" :precision="2" :min="0" >
									
								</a-input-number>
								<div class="input-number-addon">¥</div>
							</div>
						</div>
						
						<div class="detail-modal-balance-recharge-footer flex space alcenter">
							<!-- <div class="ft14 ftw600 cl-main">赠送金额</div>
							<div>
								<a-input-number  v-model="form.give_balance"  :formatter="value => `¥${value}`" :precision="2" :min="0" />
							</div> -->
						</div>
					</div>
					
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				form: {
					balance:0,
					give_balance:0,
					member:{},
					technician:{}
				},
				msgStatus:false,
				search:{
					mobile:''
				},
				showMemberLoading:false,
			}
		},
		methods: {

			//查找会员
			onSearch(){
				if(this.showMemberLoading==true) return;
				this.showMemberLoading=true;
				this.$http.api('admin/getMemberByMobile',{
					mobile:this.search.mobile,
				}).then(res=>{
					this.msgStatus=false;
					this.form.member=res.member;
					this.showMemberLoading=false;
				}).catch(res=>{
					this.showMemberLoading=false;
					this.msgStatus=true;
				})
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
	
			/**
			 * 提交数据
			 */
			onSubmit() {
				if(JSON.stringify(this.form.member) == '{}'){
					this.$message.error('请先查找用户');
					return;
				}
				if(!this.form.member.member_id){
					this.$message.error('请先查找用户');
					return;
				}
				if(this.form.balance <= 0) {
					this.$message.error('充值金额要大于0');
					return;
				}

				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/balanceRecharge',{
					member_id:this.form.member.member_id,
					balance:this.form.balance,
					give_balance:this.form.give_balance,
				}).then(res=>{
					this.$message.success('充值成功',1,()=>{
						this.confirmLoading=false;
						this.$emit("ok");
					})
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},
			
			reChooseAct(){
				this.msgStatus=false;
				this.form.member=new Object;
			},
		}
	}
</script>

<style>
	.detail-modal-balance-recharge{
		width: 360px;
		height: 186px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		padding: 0px 20px 0px 20px;
	}
	
	.detail-modal-balance-recharge-content .ant-input-number {
		font-size: 40px;
		line-height: 80px;
		font-weight: bold;
		border: none;
		color: #A6AEC2;
		width: 320px;
		height: 80px;
		border-radius: 4px;
		
	}
	
	
	.detail-modal-balance-recharge-content .ant-input-number-input {
		width: 320px;
		height: 80px;
		padding: 0 39px;
		border-radius: 4px;
	}
	
	.detail-modal-balance-recharge-content .ant-input-number-handler-wrap {
		display: none;
	}
	
	
	.detail-modal-balance-recharge-content .ant-input-number-focused {
		box-shadow: none;
	}
	
	.detail-modal-balance-recharge-content .input-number-addon{
		height: 80px;
		padding-left: 0px;
		position: absolute;
		top: 0px;
		left: 0;
		text-align: right;
		line-height: 80px;
		
		font-size: 40px;
		font-weight: bold;
		color: #232529;
	}
	
	.detail-modal-balance-recharge-footer{
		height: 63px;
		border-top: 1px solid #DCDFE6;
	}
	
	.detail-modal-balance-recharge-footer .ant-input-number {
		font-size: 20px;
		line-height: 20px;
		border: none;
		font-weight: bold;
		color: #A6AEC2;
		height: 20px;
		width: 100px;
	}
	
	.detail-modal-balance-recharge-footer .ant-input-number-input {
		width: 100px;
		height: 20px;
		border-radius: 4px;
	}
	
	.detail-modal-balance-recharge-footer .ant-input-number-focused {
		box-shadow: none;
	}
	
	.detail-modal-balance-recharge-footer .ant-input-number-handler-wrap {
		display: none;
	}
</style>
